<template>
  <div class="WizardFormModal" v-show="isShowing">
    <WizardForm v-if="isShowing"
      :options="formOptions"
      :onFormDone="hideWizardForm"
      v-bind="{ submissionMeta }"
    >
      <template v-slot:headerRight>
        <CloseButton @click="hideWizardForm"/>
      </template>
    </WizardForm>
  </div>
</template>

<script>
import bodyScroll from '~/lib/bodyScroll.js'
import pushWizardFormEvent from '../wizard/util/pushWizardFormEvent.js'

import CloseButton from '~/vue-components/shared/CloseButton.vue'
import WizardForm from '../wizard/WizardForm.vue'

function getFormOptions(brand, defaultRequestType) {
  switch (defaultRequestType) {
  case 'sales':
    return { brand, requestType: 'sales', shortForm: false }
  case 'salesShort':
    // Setting defaultRequestType to "salesShort" in Sanity is how we currently
    // indicate that we want a specific (landing) page to use the shortForm
    // variant. It would be better to change this to an actual 'shortForm' field
    // and keep requestType as 'sales' or 'support' only
    return { brand, requestType: 'sales', shortForm: true }
  case 'support':
    return { brand, requestType: 'support', shortForm: false }
  default:
    return { brand, chooseRequestType: true, shortForm: false }
  }
}

export default {
  components: {
    CloseButton,
    WizardForm,
  },
  props: {
    brand: String,
    defaultRequestType: String,
    digitalLeadType: String,
  },
  data() {
    return {
      isShowing: false,
      formOptions: {},
      incentive: '',
    }
  },
  provide() {
    return {
      updateOption: (name, value) => {
        this.formOptions[name] = value
      },
    }
  },
  computed: {
    submissionMeta() {
      return {
        digitalLeadType: this.digitalLeadType || 'Full lead form',
        incentive: this.incentive,
      }
    },
  },
  methods: {
    showWizardForm(incentive, specifiedRequestType) {
      this.formOptions = getFormOptions(this.brand, specifiedRequestType || this.defaultRequestType)
      this.incentive = incentive
      this.isShowing = true
      bodyScroll.lock()
      pushWizardFormEvent('wizard_form_opened', this.incentive, this.formOptions)
    },
    hideWizardForm() {
      pushWizardFormEvent('wizard_form_closed', this.incentive, this.formOptions)
      bodyScroll.unlock()
      this.isShowing = false
      this.formOptions = {}
      this.incentive = ''
    },
  },
  mounted() {
    this.$pageActions.register(
      'showWizardForm',
      (incentive) => this.showWizardForm(incentive)
    )
    this.$pageActions.register(
      'showSalesWizardForm',
      (incentive) => this.showWizardForm(incentive, 'sales')
    )
    this.$pageActions.register(
      'showSupportWizardForm',
      (incentive) => this.showWizardForm(incentive, 'support')
    )
  },
  beforeUnmount() {
    this.$pageActions.unregister('showWizardForm')
    this.$pageActions.unregister('showSalesWizardForm')
    this.$pageActions.unregister('showSupportWizardForm')
  },
}
</script>

<style scoped>
.WizardFormModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--bg-color-white);
  z-index: 50;
}
</style>
